<ng-template #templateSubstitute>
  <span class="d-flex icon material-symbols-outlined m-r-4"> find_replace </span>

  {{ 'productRow.actions.viewReplacement' | cxTranslate }}
</ng-template>

@if (getReplacements().length == 0) {
  <button type="button" class="btn btn-primary w-100" (click)="showNoReplacementToast()">
    <ng-container *ngTemplateOutlet="templateSubstitute"></ng-container>
  </button>
} @else if (getReplacements().length == 1) {
  <a tabindex="0" [routerLink]="
              {
                cxRoute: 'product',
                params: {
                  code: getReplacements()[0].target.code,
                  slug: slugify(getReplacements()[0].target.name),
                  catalogNumber: getReplacements()[0].target.catalogNumber,
                },
              } | cxUrl
            " class="btn btn-primary w-100">
    <ng-container *ngTemplateOutlet="templateSubstitute"></ng-container>
  </a>
} @else {
  <a tabindex="0" [routerLink]="['/products-compare']" [queryParams]="{ pids: getReplacementsIDs().join(','), originalId: product?.code }" class="btn btn-primary w-100">
    <ng-container *ngTemplateOutlet="templateSubstitute"></ng-container>
  </a>
}
